import { render, staticRenderFns } from "./searchHeadChain.vue?vue&type=template&id=a3420ff0&scoped=true"
import script from "./searchHeadChain.vue?vue&type=script&lang=js"
export * from "./searchHeadChain.vue?vue&type=script&lang=js"
import style0 from "./searchHeadChain.vue?vue&type=style&index=0&id=a3420ff0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3420ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3420ff0')) {
      api.createRecord('a3420ff0', component.options)
    } else {
      api.reload('a3420ff0', component.options)
    }
    module.hot.accept("./searchHeadChain.vue?vue&type=template&id=a3420ff0&scoped=true", function () {
      api.rerender('a3420ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/searchHeadChain.vue"
export default component.exports